import { render } from "./defultDemo.vue?vue&type=template&id=ea90e8e6"
import script from "./defultDemo.vue?vue&type=script&lang=js"
export * from "./defultDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__